import {onlyAllowed} from "../../collections.js";

export function clipboard(event, onTextPaste) {
  const data = event.clipboardData;
  if (data.types.length === 0) {
    // Clipboard can contain nothing, right after machine restart
    // or after user clears their clipboard manually.
    return;
  }
  if (onlyAllowed(data.types, ['text/plain', 'text/html', 'text/rtf'])) {
    onTextPaste(data.getData('text/plain'));
  }
}
